import * as React from "react";
import { Card } from "react-bootstrap";
import FontAwesome from "react-fontawesome";

export default function FluidCard(props) {
  switch (props.variant) {
    case "person":
      return (
        <Card style={{ width: "18rem" }} className="fluidCard">
          <Card.Img
            className="fluidCard_img"
            src={props.backgroundImage.src}
            alt={props.backgroundImage.alt}
          />
          <Card.Body className="fluidCard_body">
            <div className="fluidCard_profile_img">
              <img src={props.image.src} alt={props.image.alt}></img>
            </div>
            <h3>
              <strong>{props.name}</strong>
            </h3>
            <h5>{props.role}</h5>

            <div className="fluidCard_social_links">
              {props.socialLinks.map((link) => (
                <a href={link.href}>
                  <FontAwesome
                    name="twitter"
                    size="2x"
                    style={{ color: link.color }}
                  />
                </a>
              ))}
            </div>
          </Card.Body>
        </Card>
      );
    case "info":
      return (
        <Card style={{ width: "18rem" }} className="fluidCard">
          <Card.Img
            className="fluidCard_img"
            src={props.image.src}
            alt={props.image.alt}
          />
          <Card.Body className="fluidCard_body">
            <h3 className="fluidCard_nophoto">
              <strong>{props.title}</strong>
            </h3>
            <p className="fluidCard_paragraph">{props.children}</p>
            {props.links}
          </Card.Body>
        </Card>
      );
    default:
      return <p>Must specify a type for cards, 'info' or 'person'</p>;
  }
}
